import React from "react";
import { SiteThemeProvider } from "./src/theme/SiteThemeProvider";
import "./src/theme/global.css";

export const wrapRootElement = ({ element }) => {
  if (typeof window !== "undefined" && window.localStorage.getItem("flags")) {
    window.localStorage.removeItem("flags");
  }
  return (
    <SiteThemeProvider>
      {element}
    </SiteThemeProvider>
  );
};
